import React, { useEffect, memo } from 'react'
import { useHistory } from 'react-router-dom'
import { useDispatch } from 'react-redux'

import Title from './Title'
import Button from 'components/CommonUI/Button/Button'
import {
  getErrorRestoreTypeSelector,
  restorePassword,
  setErrorResporePasswordType,
  getRestorePasswordEmailString,
} from 'redux/reducers/profile'
import { useShallowEqualSelector } from 'custom-hooks'
import { routingConstants } from 'constants/routingConstants'

const ErrorResetPassword = () => {
  const history = useHistory()
  const dispatch = useDispatch()
  const errorType = useShallowEqualSelector(getErrorRestoreTypeSelector)
  const restorePassEmailString = useShallowEqualSelector(
    getRestorePasswordEmailString
  )

  const contentError = {
    title: '',
    message: '',
  }

  const isExpiredCode = [
    'ExpiredCodeException',
    'CodeMismatchException',
  ].includes(errorType)

  if (errorType === 'LimitExceededException') {
    contentError.title = 'Attempt limit exceeded'
    contentError.message = 'Attempt limit exceeded, please try after some time.'
  }

  if (errorType === 'InvalidParameterException') {
    contentError.title = 'Invalid Parameter Exception'
    contentError.message = "Value at 'password' failed to satisfy constraint"
  }

  if (isExpiredCode) {
    contentError.title = 'The link is invalid'
    contentError.message = 'The recovery link has already expired'
  }

  const handleClickResend = () => {
    if (history?.location?.state?.userEmail) {
      dispatch(restorePassword(history.location.state.userEmail))
    }
  }

  useEffect(() => {
    if (restorePassEmailString) {
      dispatch(setErrorResporePasswordType({ type: null }))
      history.push(routingConstants.recoveryPasswordSentEmail, {
        userEmail: history.location.state.userEmail,
      })
    }
  }, [dispatch, history, restorePassEmailString])

  useEffect(() => {
    if (!errorType && !restorePassEmailString) {
      history.push('/')
    }
  }, [errorType, history, restorePassEmailString])

  useEffect(() => {
    return () => {
      dispatch(setErrorResporePasswordType({ type: null }))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      <Title content={contentError.title} />
      <Title content={contentError.message} type="subtitle" />
      {isExpiredCode && (
        <span className="resend_link">
          <Button
            variant="text"
            fs={16}
            onClick={handleClickResend}
            className="resend_link_button"
          >
            Resend the link
          </Button>
        </span>
      )}
    </>
  )
}

export default memo(ErrorResetPassword)

//// Attempt limit exceeded, please try after some time.  /// LimitExceededException
// message: 'Invalid code provided, please request a code again.'
// __type: 'ExpiredCodeException'
